import {isNullOrUndefined} from "../../../services/Validator";
import {MathJax, MathJaxContext} from "better-react-mathjax";

export default function GlossaryDetailedTermDefinition({definition}) {
    // Used in GlossaryDetailedScreenContent to display
    // Term definition text

    // BUILD
    if (isNullOrUndefined(definition))
        return null
    return (
        <div className={"w-full flex flex-col justify-start items-start px-[12px] pt-[8px] pb-[12px] border-primaryLight3 border-[1px] rounded-[12px]"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <div className={"whitespace-pre-line text-greyLight11 text-[16px] font-medium sm:font-semibold mt-[2px]"}>
                        {definition}
                    </div>
                </MathJax>
            </MathJaxContext>
        </div>
    );
}